import { Membership, SiteLocation } from '@gym-particles/types/models';

export interface GymChainAccessCategory {
  id: number;
  siteId: number;
  name: string;
  gender: string;
  age: number;
  schedulesOnly: string;
  status: string;
  gyms: SiteLocation[];
  memberships: Membership[];
  groupId: string;
}

export interface GymChainAccessCategoryType {
  id: number;
  siteId: number;
  name: string;
  gender: string;
  age: number;
  schedulesOnly: string;
  status: string;
  siteLocationAccessCategoryId: number;
  siteLocationId: number;
  siteLocationMembershipId: number;
  accessCategoryId: number;
  locationName: string;
  arxAccessCategoryId: string;
  membershipImportedId: string;
  membershipName: string;
  program: string;
  scheduleType: string;
  createdBy: number;
  createdDate: string;
  lastModifiedBy: number;
  lastModifiedDate: string;
}

export interface GymChainAccessCategoryTable {
  id: number;
  siteId: number;
  name: string;
  gender: string;
  age: number;
  schedulesOnly: string;
  status: string;
  accessCategoryDetails: Array<{
    accessCategoryId: number;
    siteLocationAccessCategoryId: number;
    siteLocationId: number;
    siteLocationMembershipId: number;
    locationName: string;
    arxAccessCategoryId: string;
    membershipImportedId: string;
    membershipName: string;
    program: string;
    scheduleType: string;
  }>;
}

export const GymChainAccessCategoriesHeaderRoutes = {
  memberships: 0,
  bookings: 1
};

export type GymChainAccessCategoriesHeaderTabNames = keyof typeof GymChainAccessCategoriesHeaderRoutes;
